import { map, filter, isNil, max, min } from "lodash";

export default (group, workspace) => {
  const {
    requestorTypes,
    approverTypes,
    roleTypes,
    targetTypes,
    supplyLabel,
    demandLabel,
    approvalReasons,
    hideBudgetColumn,
    hideBudgetTooltip,
    financialYear,
    enableForecastSubmitting,
    enableForecastConstraints,
    enableMembersInForecast,
    enableMembersInPlanner,
    enableAddNewRole,
    enableAddNewRoleInForecast,
    enableForecastSearchView,
    forecastSearchOptions,
    forecastSearchInvalidTags,
    forecastSearchLimit,
    showMemberTags,
    enableDeparturedPeopleTagEditing,
    enableBulkAddingTag,
    enableWorkspaceAccess,
    enableWorkspaceAccessForEveryone,
    enableWorkspaceAccessForAllowList,
    initialChaptersTreeExpansionLevel,
    enableBulkMoveMembers,
    enableBulkDeallocations,
    enableBulkMoveWithUpdate,
    enableMoveGroupByTag,
    enableMoveGroups,
    enableMemberAllocation,
    enableAddMember,
    enableMembersFilter,
    showMemberMoveBadge,
    enableAddVacantRole,
    enableVacantRoleWithUpdate,
    enableMemberFteEdit,
    vacantRoleLabel,
    currentMemberFteLabel,
    totalChangeLabel,
    macroAllocationDeltaFteLabel,
    desiredInputAsDelta,
    allocateBtnLabel,
    hideAllocateButton,
    moveMemberBtnLabel,
    addTeamBtnLabel,
    groupDetailsLabelSuffix,
    groupingLineItemsLabel,
    groupingTagsLabel,
    initalExpansionLevel,
    useDeltaForBudget,
    hideApproverColumn,
    enableSearchView,
    enableSetGroupTags,
    plannerSearchOptions,
    plannerSearchInvalidTags,
    plannerSearchLimit,
    disableGroupTeamBuilder,
    enableTagsAppliedCount,
    showMacroAllocationInput,
    constraintLabel,
    totalLabel,
    enableChangeSupplyGroup,
    hideHiddenTeams,
  } = workspace.config.allocation;

  const rootTypes = map(filter(workspace.config.groupTypes, "isRoot"), "name");
  const {
    enableForecastIntersectingFte,
    enableForecastPrefillWithIntersectingFte: prefillWithIntersectingFte,
    enableForecastFteChart,
  } = workspace.config.featureFlags;

  const supplyRootTypes = map(
    filter(workspace.config.groupTypes, "isSupplyRoot"),
    "name"
  );

  return {
    parentGroupId: group.id,
    parentGroupType: group.type,
    rootTypes,
    requestorTypes,
    approverTypes,
    supplyRootTypes,
    roleTypes,
    targetTypes,
    groupLookup: {
      [group.id]: {
        ...group,
        isSource: workspace.config.groupTypes[group.type]?.isSupply,
        isDemand: workspace.config.groupTypes[group.type]?.isDemand,
      },
    },
    activeAllocationProject: {},
    allocationProjectLookup: {},
    supplyLabel,
    demandLabel,
    hideBudgetColumn,
    hideBudgetTooltip,
    approvalReasons,
    financialYear,
    enableForecastSubmitting,
    enableForecastConstraints,
    enableMembersInForecast,
    enableMembersInPlanner: isNil(enableMembersInPlanner)
      ? true
      : enableMembersInPlanner,
    enableAddNewRole: isNil(enableAddNewRole) ? true : enableAddNewRole,
    enableAddNewRoleInForecast: isNil(enableAddNewRoleInForecast)
      ? true
      : enableAddNewRoleInForecast,
    showMemberTags,
    enableDeparturedPeopleTagEditing,
    enableBulkAddingTag,
    enableWorkspaceAccess,
    enableWorkspaceAccessForEveryone,
    enableWorkspaceAccessForAllowList,
    initialChaptersTreeExpansionLevel,
    enableBulkMoveMembers,
    enableBulkDeallocations,
    enableBulkMoveWithUpdate,
    enableMoveGroups,
    enableMoveGroupByTag,
    enableMemberAllocation,
    enableAddMember,
    enableMembersFilter,
    showMemberMoveBadge,
    enableAddVacantRole,
    enableVacantRoleWithUpdate,
    enableMemberFteEdit,
    vacantRoleLabel,
    currentMemberFteLabel,
    totalChangeLabel,
    macroAllocationDeltaFteLabel,
    desiredInputAsDelta,
    allocateBtnLabel,
    hideAllocateButton,
    moveMemberBtnLabel,
    addTeamBtnLabel,
    disableGroupTeamBuilder,
    groupDetailsLabelSuffix,
    groupingLineItemsLabel,
    groupingTagsLabel,
    initalExpansionLevel: initalExpansionLevel
      ? min([max([initalExpansionLevel, 1]), 4]) // minimum 1, maximum 4
      : undefined,
    useDeltaForBudget,
    hideApproverColumn,
    enableSearchView,
    enableSetGroupTags,
    plannerSearchOptions,
    plannerSearchInvalidTags,
    plannerSearchLimit,
    enableForecastSearchView,
    enableTagsAppliedCount,
    forecastSearchOptions,
    forecastSearchInvalidTags,
    forecastSearchLimit,
    groupTypesLookup: workspace.config.groupTypes,
    showMacroAllocationInput,
    constraintLabel,
    totalLabel,
    enableForecastIntersectingFte,
    enableForecastFteChart,
    prefillWithIntersectingFte,
    enableChangeSupplyGroup,
    hideHiddenTeams,
  };
};
